import apiClient from './apiClient';
import {
  AuthResponse,
  LoginPayload,
  LogoutPayload,
  RefreshPayload,
  RegisterPayload,
} from '../types';

export async function login(payload: LoginPayload): Promise<AuthResponse> {
  const response = await apiClient.post<AuthResponse>('/auth/login', payload);
  return response.data;
}

export async function register(payload: RegisterPayload): Promise<AuthResponse> {
  const response = await apiClient.post<AuthResponse>('/auth/register', payload);
  return response.data;
}

export async function refreshToken(payload: RefreshPayload): Promise<AuthResponse> {
  const response = await apiClient.post<AuthResponse>('/auth/refresh', payload);
  return response.data;
}

export async function logout(payload: LogoutPayload): Promise<void> {
  await apiClient.post('/auth/logout', payload);
}
